import type { ScheduleModel } from '@/shared/generated'
import type { TFunction } from 'i18next'

import { format } from 'date-fns'

import { utcToZonedTime } from '@/shared/tools/dates'

export const weekdays = [
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
	'sunday',
]

export const formatSchedule = (schedule: ScheduleModel, t: TFunction) => {
	let text = ''
	text += `${t('schedule_start_on')} ${format(utcToZonedTime(new Date(schedule.start_date), 'UTC'), 'MMM dd')} \n`
	if (schedule.repeat) {
		text += `${t('schedule_repeat_on')} ${schedule.repeat_days
			?.map((d) => t(weekdays[d]).substr(0, 3))
			.join(
				', '
			)} ${t('every')} ${schedule.repeat_week_interval} ${t('general_weeks')}\n`
	}
	if (schedule.nearest_date) {
		text += `${t('schedule_next_repricing')} ${t('on')} ${format(
			utcToZonedTime(new Date(schedule.nearest_date), 'UTC'),
			'MMM dd'
		)}`
	}

	return text
}
